import { ProductKey } from "src/config/config";
import { payPlan } from "src/config/priceTypeList";
import { IGetPriceListRes } from "src/service/types/pay.type";

export const payPlanMapper = ({
  priceList,
  productKey,
}: {
  priceList: IGetPriceListRes[];
  productKey: ProductKey;
}) => {
  const payPlanTemp = { ...payPlan };
  priceList?.forEach((price, idx) => {
    // TODO 요금제 옵션 쉽게 관리할 방법 찾기
    if (
      ["drive", "basic", "plus", "basicPlus", "plusPlus"].includes(
        price.priceType
      )
    ) {
      if (price.currency === "WON") {
        // @ts-ignore
        payPlanTemp[productKey][price.priceType].ko.month = price.userPerPrice;
        // @ts-ignore
        payPlanTemp[productKey][price.priceType].ko.year =
          price.userPerPriceYear;
      } else if (price.currency === "USD") {
        // @ts-ignore
        payPlanTemp[productKey][price.priceType].en.month = price.userPerPrice;
        // @ts-ignore
        payPlanTemp[productKey][price.priceType].en.year =
          price.userPerPriceYear;
      }
    }
  });

  // console.log("payPlanTemp", payPlanTemp);
  // console.log("test", payPlanTemp["WRAPSODY"]["basic"]["ko"]);
  // setPayPlanInfo((prev) => ({ ...prev, ...payPlanTemp }));

  return payPlanTemp;
};
